
import ApplicationState from "../../../../../../../ApplicationState"
import IDispatcher from "../../../../../../Util/IDispatcher"
import IState from "../../../../../../Util/IState"
import OrderUI from "./OrderUI"
import { actionFetchOrders } from "../../Actions/ActionCreator"
import IndexDispatch from "./model"
import { Dispatch } from "redux"
import { connect } from "react-redux"
import OrderState from "../../State/OrderState"

const mapStateToProps = (state: ApplicationState): IState<OrderState> => {
    return {
        state: state.orders
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<IndexDispatch> => ({
    dispatcher: {
        fetch: () => { dispatch(actionFetchOrders() as any) }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(OrderUI)